import React from 'react';

import { JobStatusStyledIconContainer } from '@/console/features/jobs/components/job-status-styled-icon/job-status-style-icon.styled';
import { TJobStatusStyledIconProps } from '@/console/features/jobs/components/job-status-styled-icon/job-status-styled-icon.types';
import { Tooltip } from '@/shared/components/ui/tooltip/tooltip';
import { useJobStatus } from '@/shared/features/jobs/hooks/use-job-status/use-job-status';

export const JobStatusStyledIcon: React.FC<TJobStatusStyledIconProps> = ({
  status,
}) => {
  const { getStatusIcon, getStatusLabel, getStatusColor } = useJobStatus();

  return (
    <Tooltip title={getStatusLabel(status)} placement="left" arrow>
      <JobStatusStyledIconContainer $status={getStatusColor(status)}>
        {getStatusIcon(status)}
      </JobStatusStyledIconContainer>
    </Tooltip>
  );
};
